module.exports = ".landing {\n  padding-top: 100px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/landing/landing.component.scss
// module id = ./src/app/landing/landing.component.scss
// module chunks = main